import { InjectionToken } from '@angular/core';

export const LLT = new InjectionToken<string>('LLTToken');
